import { useContentSelector } from '@wajeez-web/stores/content';

export const useContentEntityTypeNavigationsDataTable = () => {
  return useContentSelector(
    ({ contentEntityTypeNavigations }) => contentEntityTypeNavigations.dataTable
  );
};

export const useGetContentEntityTypeNavigationById = () => {
  return useContentSelector(
    ({ contentEntityTypeNavigations }) => contentEntityTypeNavigations.getById
  );
};

export const useCreateContentEntityTypeNavigation = () => {
  return useContentSelector(
    ({ contentEntityTypeNavigations }) => contentEntityTypeNavigations.create
  );
};

export const useEditContentEntityTypeNavigation = () => {
  return useContentSelector(
    ({ contentEntityTypeNavigations }) => contentEntityTypeNavigations.edit
  );
};
